export const customFiltersSelector = (state) => state.customFilters;
